import script from "./vmsMainGrid.vue?vue&type=script&lang=js"
export * from "./vmsMainGrid.vue?vue&type=script&lang=js"

import "./vmsMainGrid.vue?vue&type=style&index=0&id=2a2ba940&lang=css"
import "./vmsMainGrid.vue?vue&type=style&index=1&id=2a2ba940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2ba940"]])

export default __exports__